export const getJSON = async function (url) {
  try {
    const res = await fetch(url);
    return res;
  } catch (err) {
    console.log(err);
  }
};
